export default __webpack_public_path__ + "static/media/345.0bc76625.png";